
import Vue from "vue";
import CarouselBanner from "@/components/organisms/CarouselBanner.vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    CarouselBanner,
  },
  computed: {
    isActivePath() {
      return (name) => {
        const { path } = this.$route;
        return path === name || path === `${name}/`;
      };
    },
  },
});

interface Props {}

interface Data {}

interface Computed {
  isActivePath(name: string): boolean;
}

interface Methods {}
